module.exports = __webpack_public_path__ + "img/news.085f3b0f.png";